import { Option } from "../../models";
export const education: Option[] = [
    { label: "Master degree", value: "Master degree" },
    { label: "Bachelor degree", value: "Bachelor degree" },
    { label: "PhD", value: "PHD" },
    { label: "Associate degree", value: "Associate degree" },
    { label: "High School", value: "High school" },
    { label: "Others", value: "Others" },
];